import React from "react";
import Layout from "./Layout";
import { ValidationProps } from "../../types";

interface DashboardProps extends ValidationProps {
	activeStep: number;
}

const Dashboard: React.FC<DashboardProps> = ({
	value,
	valid,
	validation,
	handleChange,
	shouldValidate,
	activeStep,
}) => {
	return (
		<Layout
			value={value}
			valid={valid}
			validation={validation}
			handleChange={handleChange}
			shouldValidate={shouldValidate}
			activeStep={activeStep}
		/>
	);
};

export default Dashboard;
